import { oc } from '@orpc/contract';
import { newRouteVersionInputSchema, routeSchema } from '../schemas/routes.schemas.js';
export const newRouteVersionContract = oc
    .route({
    method: 'POST',
    path: '/routes/{id}/new-version',
    tags: ['Routes'],
    summary: 'Copy a route into the next version and supersede the current one',
    description: 'MANAGER only. Returns the new revision; the source revision becomes SUPERSEDED.',
})
    .input(newRouteVersionInputSchema)
    .output(routeSchema);
//# sourceMappingURL=new-route-version.contract.js.map